import React from 'react';

/**
 * La bandera de un país, como SVG.
 *
 * ── Por qué no el emoji ──────────────────────────────────────────────────────
 *
 * `COUNTRIES[].flag` guardaba 🇦🇷 y 🇪🇸, que son pares de «indicadores
 * regionales»: dos letras que la fuente debe saber combinar en un dibujo.
 * **Windows no trae esos glifos**, así que en la mayoría de los escritorios se
 * veían literalmente las letras «AR» y «ES» — no rotas, sino la representación
 * de reserva del propio Unicode.
 *
 * Las alternativas eran cargar una fuente de emojis entera para dos dibujos, o
 * dibujarlos. Dos rectángulos y un círculo pesan menos que cualquier fuente y
 * se ven igual en todos lados, así que se dibujan.
 *
 * El sol argentino va como un círculo liso a propósito: a 16px los rayos se
 * convierten en una mancha, y una mancha se lee peor que un círculo limpio.
 */

const BANDERAS = {
  AR: (
    <>
      <rect width="24" height="16" fill="#74ACDF" />
      <rect y="5.33" width="24" height="5.34" fill="#fff" />
      <circle cx="12" cy="8" r="1.9" fill="#F6B40E" />
    </>
  ),
  ES: (
    <>
      <rect width="24" height="16" fill="#AA151B" />
      {/* La franja amarilla ocupa la mitad, no un tercio: es lo que hace que se
          lea como España y no como una bandera cualquiera de tres bandas. */}
      <rect y="4" width="24" height="8" fill="#F1BF00" />
    </>
  ),
};

export const Bandera = ({ code, size = 16, className = '', title }) => {
  const dibujo = BANDERAS[String(code || '').toUpperCase()];
  if (!dibujo) return null;

  return (
    <svg
      className={`bandera ${className}`.trim()}
      // Qué país dibuja. El SVG no lo dice de ninguna otra forma —no lleva
      // texto y es decorativo— así que sin esto no hay manera de comprobar que
      // se está mostrando la bandera correcta, ni desde la QA ni a simple vista
      // en el inspector.
      data-pais={String(code).toUpperCase()}
      width={size}
      height={(size * 2) / 3}
      viewBox="0 0 24 16"
      // Decorativa salvo que se le dé un título: al lado siempre va el nombre
      // del país, y repetirlo obligaría al lector de pantalla a decirlo dos
      // veces.
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      {title && <title>{title}</title>}
      {dibujo}
    </svg>
  );
};

export default Bandera;
